import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateFeatureProperties } from '../../actions/features';
import { closeSearchResultsSidebar } from '../../actions/searchResults';
import { SidebarCommonHeader } from '../../components/SidebarCommonHeader';
import { selectActiveFeature, selectNewbuildingId } from '../../selectors/features';
import { trackCloseSidebar } from '../../utils/tracking';

export const SidebarCommonHeaderContainer: React.FC = () => {
  const dispatch = useDispatch();
  const newbuildingId = useSelector(selectNewbuildingId);
  const activeFeature = useSelector(selectActiveFeature);

  const handleClose = React.useCallback(() => {
    dispatch(closeSearchResultsSidebar());
    trackCloseSidebar(newbuildingId);

    if (activeFeature) {
      dispatch(
        updateFeatureProperties({
          featureId: activeFeature.id,
          precision: activeFeature.precision,
          properties: { isActive: false, isHovered: false },
        }),
      );
    }
  }, [activeFeature, dispatch, newbuildingId]);

  return <SidebarCommonHeader onClose={handleClose} />;
};

SidebarCommonHeaderContainer.displayName = 'SidebarCommonHeaderContainer';
